import React from 'react';
import { FaMinus, FaPlus, FaPen } from 'react-icons/fa';
import { getPermissionState } from '../../../../../../../../utils/functions';
import './QuantitySelector.scss';

interface QuantitySelectorProps {
  quantity: number;
  allowEdit: boolean;
  onIncrease: () => void;
  onDecrease: () => void;
  itemName: string;
  isGranel?: boolean;
  unitAcronym?: string;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  allowEdit,
  onIncrease,
  onDecrease,
  itemName,
  isGranel = false,
  unitAcronym
}) => {
  // For granel items, display like in the cart
  if (isGranel) {
    return (
      <div className="quantity-selector granel-display">
        <span className="granel-quantity-text">
          {quantity} {unitAcronym}
        </span>
        {/* Edit button disabled for now - will implement edit logic in the future */}
        {false && allowEdit && getPermissionState(122) && (
          <button
            type="button"
            className="edit-granel-button"
            onClick={onIncrease} // We'll use onIncrease as the edit handler
            aria-label={`Editar cantidad de granel de ${itemName}`}
          >
            <FaPen />
          </button>
        )}
      </div>
    );
  }

  // Regular quantity selector for non-granel items
  return (
    <div className="quantity-selector">
      <button
        type="button"
        className="quantity-button decrement"
        onClick={onDecrease}
        disabled={!(quantity > 1 && allowEdit && getPermissionState(122))}
        aria-label={`Disminuir cantidad de ${itemName}`}
      >
        <FaMinus />
      </button>
      <span className="selection-quantity">
        {quantity}
      </span>
      <button
        type="button"
        className="quantity-button increment"
        onClick={onIncrease}
        disabled={!allowEdit || !getPermissionState(122)}
        aria-label={`Aumentar cantidad de ${itemName}`}
      >
        <FaPlus />
      </button>
    </div>
  );
};

export default QuantitySelector;
